@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import ai.jessie.web.pages.homePage as _ai_jessie_web_pages_homePage
import ai.jessie.web.pages.onboardingPage as _ai_jessie_web_pages_onboardingPage
import ai.jessie.web.pages.organisations.organisationCalendarPage as _ai_jessie_web_pages_organisations_organisationCalendarPage
import ai.jessie.web.pages.organisations.organisationCustomerBillingPage as _ai_jessie_web_pages_organisations_organisationCustomerBillingPage
import ai.jessie.web.pages.organisations.organisationCustomerPage as _ai_jessie_web_pages_organisations_organisationCustomerPage
import ai.jessie.web.pages.organisations.organisationCustomersPage as _ai_jessie_web_pages_organisations_organisationCustomersPage
import ai.jessie.web.pages.organisations.organisationDocumentPage as _ai_jessie_web_pages_organisations_organisationDocumentPage
import ai.jessie.web.pages.organisations.organisationDocumentsPage as _ai_jessie_web_pages_organisations_organisationDocumentsPage
import ai.jessie.web.pages.organisations.organisationInvoicePage as _ai_jessie_web_pages_organisations_organisationInvoicePage
import ai.jessie.web.pages.organisations.organisationInvoicesPage as _ai_jessie_web_pages_organisations_organisationInvoicesPage
import ai.jessie.web.pages.organisations.organisationMembersPage as _ai_jessie_web_pages_organisations_organisationMembersPage
import ai.jessie.web.pages.organisations.organisationPage as _ai_jessie_web_pages_organisations_organisationPage
import ai.jessie.web.pages.organisations.organisationProjectPage as _ai_jessie_web_pages_organisations_organisationProjectPage
import ai.jessie.web.pages.organisations.organisationProjectsPage as _ai_jessie_web_pages_organisations_organisationProjectsPage
import ai.jessie.web.pages.organisations.organisationSettingsPage as _ai_jessie_web_pages_organisations_organisationSettingsPage
import ai.jessie.web.pages.organisations.organisationWorkEntryPage as _ai_jessie_web_pages_organisations_organisationWorkEntryPage
import ai.jessie.web.pages.organisations.organisationWorkPage as _ai_jessie_web_pages_organisations_organisationWorkPage
import ai.jessie.web.pages.organisations.organisationsPage as _ai_jessie_web_pages_organisations_organisationsPage
import ai.jessie.web.pages.profile.emailResultPage as _ai_jessie_web_pages_profile_emailResultPage
import ai.jessie.web.pages.profile.profilePage as _ai_jessie_web_pages_profile_profilePage
import ai.jessie.web.pages.registration.invalidPage as _ai_jessie_web_pages_registration_invalidPage
import ai.jessie.web.pages.registration.neutralPage as _ai_jessie_web_pages_registration_neutralPage
import ai.jessie.web.pages.registration.unavailablePage as _ai_jessie_web_pages_registration_unavailablePage
import ai.jessie.web.pages.styleguidePage as _ai_jessie_web_pages_styleguidePage
import ai.jessie.web.pages.supportPage as _ai_jessie_web_pages_supportPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Jessie"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _ai_jessie_web_pages_homePage()
        }
        ctx.router.register(
            "/onboarding",
        ) { pageCtx -> 
            _ai_jessie_web_pages_onboardingPage()
        }
        ctx.router.register(
            "/organisations/",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationsPage()
        }
        ctx.router.register(
            "/organisations/{organisationId}",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/calendar",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationCalendarPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/customer-billing",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationCustomerBillingPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/customers",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationCustomersPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/customers/{customerId}",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationCustomerPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/documents",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationDocumentsPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/documents/{documentId}",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationDocumentPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/invoices",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationInvoicesPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/invoices/{invoiceId}",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationInvoicePage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/members",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationMembersPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/projects",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationProjectsPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/projects/{projectId}",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationProjectPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/settings",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationSettingsPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/work",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationWorkPage(pageCtx)
        }
        ctx.router.register(
            "/organisations/{organisationId}/work/{workId}",
        ) { pageCtx -> 
            _ai_jessie_web_pages_organisations_organisationWorkEntryPage(pageCtx)
        }
        ctx.router.register(
            "/profile/",
        ) { pageCtx -> 
            _ai_jessie_web_pages_profile_profilePage(pageCtx)
        }
        ctx.router.register(
            "/profile/email-result",
        ) { pageCtx -> 
            _ai_jessie_web_pages_profile_emailResultPage(pageCtx)
        }
        ctx.router.register(
            "/registration/invalid",
        ) { pageCtx -> 
            _ai_jessie_web_pages_registration_invalidPage()
        }
        ctx.router.register(
            "/registration/neutral",
        ) { pageCtx -> 
            _ai_jessie_web_pages_registration_neutralPage()
        }
        ctx.router.register(
            "/registration/unavailable",
        ) { pageCtx -> 
            _ai_jessie_web_pages_registration_unavailablePage(pageCtx)
        }
        ctx.router.register(
            "/styleguide",
        ) { pageCtx -> 
            _ai_jessie_web_pages_styleguidePage()
        }
        ctx.router.register(
            "/support",
        ) { pageCtx -> 
            _ai_jessie_web_pages_supportPage()
        }

        ai.jessie.web.initLinkRouting(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("calendar-arrow", ai.jessie.web.theme.CalendarArrowStyle)
        ctx.theme.registerStyle("small-button", ai.jessie.web.theme.SmallButtonStyle)
        ctx.theme.registerStyle("icon-button", ai.jessie.web.theme.IconButtonStyle)
        ctx.theme.registerStyle("small-icon-button", ai.jessie.web.theme.SmallIconButtonStyle)
        ctx.theme.registerStyle("badge", ai.jessie.web.theme.BadgeStyle)
        ctx.theme.registerStyle("chip", ai.jessie.web.theme.ChipStyle)
        ctx.theme.registerStyle("segmented", ai.jessie.web.theme.SegmentedStyle)
        ctx.theme.registerStyle("segment", ai.jessie.web.theme.SegmentStyle)
        ctx.theme.registerStyle("tabs", ai.jessie.web.theme.TabsStyle)
        ctx.theme.registerStyle("tab", ai.jessie.web.theme.TabStyle)
        ctx.theme.registerStyle("fieldset", ai.jessie.web.theme.FieldsetStyle)
        ctx.theme.registerStyle("legend", ai.jessie.web.theme.LegendStyle)
        ctx.theme.registerStyle("form-stack", ai.jessie.web.theme.FormStackStyle)
        ctx.theme.registerStyle("field", ai.jessie.web.theme.FieldStyle)
        ctx.theme.registerStyle("field-optional", ai.jessie.web.theme.FieldOptionalStyle)
        ctx.theme.registerStyle("field-error", ai.jessie.web.theme.FieldErrorStyle)
        ctx.theme.registerStyle("field-input", ai.jessie.web.theme.FieldInputStyle)
        ctx.theme.registerStyle("num-input", ai.jessie.web.theme.NumInputStyle)
        ctx.theme.registerStyle("text-area", ai.jessie.web.theme.TextAreaStyle)
        ctx.theme.registerStyle("check", ai.jessie.web.theme.CheckStyle)
        ctx.theme.registerStyle("check-hint", ai.jessie.web.theme.CheckHintStyle)
        ctx.theme.registerStyle("choice-cards", ai.jessie.web.theme.ChoiceCardsStyle)
        ctx.theme.registerStyle("choice-card", ai.jessie.web.theme.ChoiceCardStyle)
        ctx.theme.registerStyle("choice-hint", ai.jessie.web.theme.ChoiceHintStyle)
        ctx.theme.registerStyle("scrim", ai.jessie.web.theme.ScrimStyle)
        ctx.theme.registerStyle("slide-over", ai.jessie.web.theme.SlideOverStyle)
        ctx.theme.registerStyle("slide-over-head", ai.jessie.web.theme.SlideOverHeadStyle)
        ctx.theme.registerStyle("slide-over-body", ai.jessie.web.theme.SlideOverBodyStyle)
        ctx.theme.registerStyle("slide-over-foot", ai.jessie.web.theme.SlideOverFootStyle)
        ctx.theme.registerStyle("slide-over-actions", ai.jessie.web.theme.SlideOverActionsStyle)
        ctx.theme.registerStyle("num", ai.jessie.web.theme.NumStyle)
        ctx.theme.registerStyle("brand", ai.jessie.web.theme.BrandStyle)
        ctx.theme.registerStyle("label", ai.jessie.web.theme.LabelStyle)
        ctx.theme.registerStyle("muted", ai.jessie.web.theme.MutedStyle)
        ctx.theme.registerStyle("small", ai.jessie.web.theme.SmallStyle)
        ctx.theme.registerStyle("row", ai.jessie.web.theme.RowStyle)
        ctx.theme.registerStyle("stack", ai.jessie.web.theme.StackStyle)
        ctx.theme.registerStyle("grid2", ai.jessie.web.theme.Grid2Style)
        ctx.theme.registerStyle("grid3", ai.jessie.web.theme.Grid3Style)
        ctx.theme.registerStyle("pre-line", ai.jessie.web.theme.PreLineStyle)
        ctx.theme.registerStyle("sub-list", ai.jessie.web.theme.SubListStyle)
        ctx.theme.registerStyle("visually-hidden", ai.jessie.web.theme.VisuallyHiddenStyle)
        ctx.theme.registerStyle("status", ai.jessie.web.theme.StatusStyle)
        ctx.theme.registerStyle("alert", ai.jessie.web.theme.AlertStyle)
        ctx.theme.registerStyle("alert-list", ai.jessie.web.theme.AlertListStyle)
        ctx.theme.registerStyle("hint", ai.jessie.web.theme.HintStyle)
        ctx.theme.registerStyle("notice", ai.jessie.web.theme.NoticeStyle)
        ctx.theme.registerStyle("calendar-toolbar-title", ai.jessie.web.theme.CalendarToolbarTitleStyle)
        ctx.theme.registerStyle("calendar-toolbar", ai.jessie.web.theme.CalendarToolbarStyle)
        ctx.theme.registerStyle("calendar-month", ai.jessie.web.theme.CalendarMonthStyle)
        ctx.theme.registerStyle("calendar-month-title", ai.jessie.web.theme.CalendarMonthTitleStyle)
        ctx.theme.registerStyle("calendar-day-control", ai.jessie.web.theme.CalendarDayControlStyle)
        ctx.theme.registerStyle("calendar-sum", ai.jessie.web.theme.CalendarSumStyle)
        ctx.theme.registerStyle("calendar-summary", ai.jessie.web.theme.CalendarSummaryStyle)
        ctx.theme.registerStyle("calendar-scroll", ai.jessie.web.theme.CalendarScrollStyle)
        ctx.theme.registerStyle("calendar-week", ai.jessie.web.theme.CalendarWeekStyle)
        ctx.theme.registerStyle("calendar-week-day", ai.jessie.web.theme.CalendarWeekDayStyle)
        ctx.theme.registerStyle("calendar-week-head", ai.jessie.web.theme.CalendarWeekHeadStyle)
        ctx.theme.registerStyle("calendar-all-day", ai.jessie.web.theme.CalendarAllDayStyle)
        ctx.theme.registerStyle("calendar-event", ai.jessie.web.theme.CalendarEventStyle)
        ctx.theme.registerStyle("calendar-table", ai.jessie.web.theme.CalendarTableStyle)
        ctx.theme.registerStyle("calendar-table-row", ai.jessie.web.theme.CalendarTableRowStyle)
        ctx.theme.registerStyle("work-table", ai.jessie.web.theme.WorkTableStyle)
        ctx.theme.registerStyle("work-table-row", ai.jessie.web.theme.WorkTableRowStyle)
        ctx.theme.registerStyle("customer-table", ai.jessie.web.theme.CustomerTableStyle)
        ctx.theme.registerStyle("customer-table-row", ai.jessie.web.theme.CustomerTableRowStyle)
        ctx.theme.registerStyle("vat-table", ai.jessie.web.theme.VatTableStyle)
        ctx.theme.registerStyle("vat-table-row", ai.jessie.web.theme.VatTableRowStyle)
        ctx.theme.registerStyle("project-table", ai.jessie.web.theme.ProjectTableStyle)
        ctx.theme.registerStyle("project-table-row", ai.jessie.web.theme.ProjectTableRowStyle)
        ctx.theme.registerStyle("invoice-table", ai.jessie.web.theme.InvoiceTableStyle)
        ctx.theme.registerStyle("invoice-table-row", ai.jessie.web.theme.InvoiceTableRowStyle)
        ctx.theme.registerStyle("invoice-line-table", ai.jessie.web.theme.InvoiceLineTableStyle)
        ctx.theme.registerStyle("invoice-line-table-row", ai.jessie.web.theme.InvoiceLineTableRowStyle)
        ctx.theme.registerStyle("table-num-head", ai.jessie.web.theme.TableNumHeadStyle)
        ctx.theme.registerStyle("invoice-totals", ai.jessie.web.theme.InvoiceTotalsStyle)
        ctx.theme.registerStyle("invoice-layout", ai.jessie.web.theme.InvoiceLayoutStyle)
        ctx.theme.registerStyle("document-layout", ai.jessie.web.theme.DocumentLayoutStyle)
        ctx.theme.registerStyle("document-list", ai.jessie.web.theme.DocumentListStyle)
        ctx.theme.registerStyle("document-item", ai.jessie.web.theme.DocumentItemStyle)
        ctx.theme.registerStyle("document-thumb", ai.jessie.web.theme.DocumentThumbStyle)
        ctx.theme.registerStyle("document-item-text", ai.jessie.web.theme.DocumentItemTextStyle)
        ctx.theme.registerStyle("document-item-title", ai.jessie.web.theme.DocumentItemTitleStyle)
        ctx.theme.registerStyle("document-item-meta", ai.jessie.web.theme.DocumentItemMetaStyle)
        ctx.theme.registerStyle("document-progress", ai.jessie.web.theme.DocumentProgressStyle)
        ctx.theme.registerStyle("document-progress-bar", ai.jessie.web.theme.DocumentProgressBarStyle)
        ctx.theme.registerStyle("progress-steps", ai.jessie.web.theme.ProgressStepsStyle)
        ctx.theme.registerStyle("stat-bar", ai.jessie.web.theme.StatBarStyle)
        ctx.theme.registerStyle("stat-value", ai.jessie.web.theme.StatValueStyle)
        ctx.theme.registerStyle("position-list", ai.jessie.web.theme.PositionListStyle)
        ctx.theme.registerStyle("position-card", ai.jessie.web.theme.PositionCardStyle)
        ctx.theme.registerStyle("position-kind", ai.jessie.web.theme.PositionKindStyle)
        ctx.theme.registerStyle("position-name", ai.jessie.web.theme.PositionNameStyle)
        ctx.theme.registerStyle("position-stats", ai.jessie.web.theme.PositionStatsStyle)
        ctx.theme.registerStyle("table-span", ai.jessie.web.theme.TableSpanStyle)
        ctx.theme.registerStyle("table-icon", ai.jessie.web.theme.TableIconStyle)
        ctx.theme.registerStyle("person-list", ai.jessie.web.theme.PersonListStyle)
        ctx.theme.registerStyle("person", ai.jessie.web.theme.PersonStyle)
        ctx.theme.registerStyle("member-grid", ai.jessie.web.theme.MemberGridStyle)
        ctx.theme.registerStyle("member-card", ai.jessie.web.theme.MemberCardStyle)
        ctx.theme.registerStyle("pending-card", ai.jessie.web.theme.PendingCardStyle)
        ctx.theme.registerStyle("member-head", ai.jessie.web.theme.MemberHeadStyle)
        ctx.theme.registerStyle("member-name", ai.jessie.web.theme.MemberNameStyle)
        ctx.theme.registerStyle("member-actions", ai.jessie.web.theme.MemberActionsStyle)
        ctx.theme.registerStyle("table-strong", ai.jessie.web.theme.TableStrongStyle)
        ctx.theme.registerStyle("definitions", ai.jessie.web.theme.DefinitionsStyle)
        ctx.theme.registerStyle("table", ai.jessie.web.theme.TableStyle)
        ctx.theme.registerStyle("table-row", ai.jessie.web.theme.TableRowStyle)
        ctx.theme.registerStyle("table-num", ai.jessie.web.theme.TableNumStyle)
        ctx.theme.registerStyle("day", ai.jessie.web.theme.DayStyle)
        ctx.theme.registerStyle("top-nav", ai.jessie.web.theme.TopNavStyle)
        ctx.theme.registerStyle("nav-brand", ai.jessie.web.theme.NavBrandStyle)
        ctx.theme.registerStyle("nav-link", ai.jessie.web.theme.NavLinkStyle)
        ctx.theme.registerStyle("nav-spacer", ai.jessie.web.theme.NavSpacerStyle)
        ctx.theme.registerStyle("nav-timer", ai.jessie.web.theme.NavTimerStyle)
        ctx.theme.registerStyle("nav-icon", ai.jessie.web.theme.NavIconStyle)
        ctx.theme.registerStyle("avatar", ai.jessie.web.theme.AvatarStyle)
        ctx.theme.registerStyle("profile-avatar", ai.jessie.web.theme.ProfileAvatarStyle)
        ctx.theme.registerStyle("member-avatar", ai.jessie.web.theme.MemberAvatarStyle)
        ctx.theme.registerStyle("pending-avatar", ai.jessie.web.theme.PendingAvatarStyle)
        ctx.theme.registerStyle("page", ai.jessie.web.theme.PageStyle)
        ctx.theme.registerStyle("page-header", ai.jessie.web.theme.PageHeaderStyle)
        ctx.theme.registerStyle("page-header-title", ai.jessie.web.theme.PageHeaderTitleStyle)
        ctx.theme.registerStyle("page-header-kicker", ai.jessie.web.theme.PageHeaderKickerStyle)
        ctx.theme.registerStyle("page-header-sub", ai.jessie.web.theme.PageHeaderSubStyle)
        ctx.theme.registerStyle("page-header-actions", ai.jessie.web.theme.PageHeaderActionsStyle)
        ctx.theme.registerStyle("crumb", ai.jessie.web.theme.CrumbStyle)
        ctx.theme.registerStyle("crumb-current", ai.jessie.web.theme.CrumbCurrentStyle)
        ctx.theme.registerStyle("kpi", ai.jessie.web.theme.KpiStyle)
        ctx.theme.registerStyle("kpi-value", ai.jessie.web.theme.KpiValueStyle)
        ctx.theme.registerStyle("kpi-unit", ai.jessie.web.theme.KpiUnitStyle)
        ctx.theme.registerStyle("columns", ai.jessie.web.theme.ColumnsStyle)
        ctx.theme.registerStyle("side-nav", ai.jessie.web.theme.SideNavStyle)
        ctx.theme.registerStyle("side-item", ai.jessie.web.theme.SideItemStyle)
        ctx.theme.registerStyle("side-count", ai.jessie.web.theme.SideCountStyle)
        ctx.theme.registerStyle("side-group", ai.jessie.web.theme.SideGroupStyle)
        ctx.theme.registerStyle("card-stack", ai.jessie.web.theme.CardStackStyle)
        ctx.theme.registerStyle("card", ai.jessie.web.theme.CardStyle)
        ctx.theme.registerStyle("card-body", ai.jessie.web.theme.CardBodyStyle)
        ctx.theme.registerStyle("card-head", ai.jessie.web.theme.CardHeadStyle)
        ctx.theme.registerStyle("card-head-row", ai.jessie.web.theme.CardHeadRowStyle)
        ctx.theme.registerStyle("disclosure", ai.jessie.web.theme.DisclosureStyle)
        ctx.theme.registerStyle("card-foot", ai.jessie.web.theme.CardFootStyle)
        ctx.theme.registerStyle("text-card", ai.jessie.web.theme.TextCardStyle)
        ctx.theme.registerStyle("entry-card", ai.jessie.web.theme.EntryCardStyle)
        ctx.theme.registerStyle("entry-foot", ai.jessie.web.theme.EntryFootStyle)
        ctx.theme.registerVariant("-primary", ai.jessie.web.theme.PrimaryButtonVariant)
        ctx.theme.registerVariant("-tint", ai.jessie.web.theme.TintButtonVariant)
        ctx.theme.registerVariant("-secondary", ai.jessie.web.theme.SecondaryButtonVariant)
        ctx.theme.registerVariant("-ghost", ai.jessie.web.theme.GhostButtonVariant)
        ctx.theme.registerVariant("-dark", ai.jessie.web.theme.DarkButtonVariant)
        ctx.theme.registerVariant("-danger", ai.jessie.web.theme.DangerButtonVariant)
        ctx.theme.registerVariant("-hours", ai.jessie.web.theme.HoursBadgeVariant)
        ctx.theme.registerVariant("-primary", ai.jessie.web.theme.PrimaryBadgeVariant)
        ctx.theme.registerVariant("-accent", ai.jessie.web.theme.AccentBadgeVariant)
        ctx.theme.registerVariant("-danger", ai.jessie.web.theme.DangerBadgeVariant)
        ctx.theme.registerVariant("-warning", ai.jessie.web.theme.WarningBadgeVariant)
        ctx.theme.registerVariant("-head", ai.jessie.web.theme.HeadTableRowVariant)
        ctx.theme.registerVariant("-group", ai.jessie.web.theme.GroupTableRowVariant)
        ctx.theme.registerVariant("-total", ai.jessie.web.theme.TotalTableRowVariant)
        ctx.theme.registerVariant("-heat0", ai.jessie.web.theme.Heat0DayVariant)
        ctx.theme.registerVariant("-heat1", ai.jessie.web.theme.Heat1DayVariant)
        ctx.theme.registerVariant("-heat2", ai.jessie.web.theme.Heat2DayVariant)
        ctx.theme.registerVariant("-heat3", ai.jessie.web.theme.Heat3DayVariant)
        ctx.theme.registerVariant("-heat4", ai.jessie.web.theme.Heat4DayVariant)
        ctx.theme.registerVariant("-heat5", ai.jessie.web.theme.Heat5DayVariant)
        ctx.theme.registerVariant("-today", ai.jessie.web.theme.TodayDayVariant)
        ai.jessie.web.theme.initJessieButton(ctx)
        ai.jessie.web.theme.initJessieTheme(ctx)
        ai.jessie.web.theme.initColorMode(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        ai.jessie.web.appEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
